import { createApi } from '@reduxjs/toolkit/query/react';
import { createBackendBaseQuery, transformApiError } from '../../../utils/createAuthBaseQuery';
import { API_URLS } from '../../../constants/apiUrl';

export interface ElektronikonInvestigation {
  id: string;
  modelName: string;
  region: string;
  active: boolean;
  oldController: string;
  newController: string;
  oldControllerPartNumber: string;
  newControllerPartNumber: string;
  kitNumber: string;
  converter: string;
}

export interface ElektronikonInvestigationSearchResponse {
  totalResult: number;
  activeResult: number;
  elektronikonInvestigations: ElektronikonInvestigation[];
}

export interface FetchElektronikonInvestigationParams {
  page?: number;
  limit?: number;
  sort?: keyof ElektronikonInvestigation;
  order?: 'asc' | 'desc';
  [key: string]: string | number | undefined;
}

const BASE_URL = process.env.REACT_APP_ELEKTRONIKON_SERVICE_API_BASE_URL as string;

if (!BASE_URL) {
  throw new Error('REACT_APP_ELEKTRONIKON_SERVICE_API_BASE_URL environment variable is not set');
}

export const elektronikonInvestigationApiSlice = createApi({
  reducerPath: 'elektronikonInvestigationApi',
  baseQuery: createBackendBaseQuery(BASE_URL),
  tagTypes: ['ElektronikonInvestigation'],
  endpoints(builders) {
    return {
      fetchElektronikonInvestigations: builders.query<
        ElektronikonInvestigationSearchResponse,
        FetchElektronikonInvestigationParams | void
      >({
        query: (params) => {
          let queryString = '';
          if (params) {
            const usp = new URLSearchParams();
            Object.entries(params).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== '') {
                usp.append(key, String(value));
              }
            });
            queryString = usp.toString() ? `?${usp.toString()}` : '';
          }
          return {
            url: `${API_URLS.ELEKTRONIKON.SEARCH}${queryString}`,
            method: 'GET',
          };
        },
        providesTags: [{ type: 'ElektronikonInvestigation', id: 'LIST' }],
        transformErrorResponse: transformApiError,
      }),
    };
  },
});

export const {
  useFetchElektronikonInvestigationsQuery,
  useLazyFetchElektronikonInvestigationsQuery,
} = elektronikonInvestigationApiSlice;
